(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_913137c"] && !Shopify.designMode) return;
  try {
    (() => {
    const tagName = 'sct-image-link-dots';
    if (customElements.get(tagName)) return;

    customElements.define(tagName, class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.hoveredDot = null;
        this.focusedDot = null;
        this.activeDot = null;
        const update = () => this.showDot(this.hoveredDot || this.focusedDot);

        this.querySelectorAll('[data-dot]').forEach((dot) => {
          dot.classList.remove('is-active');

          dot.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'touch') return;
            this.hoveredDot = dot;
            update();
          }, options);

          dot.addEventListener('pointerleave', () => {
            if (this.hoveredDot === dot) this.hoveredDot = null;
            update();
          }, options);

          dot.addEventListener('focus', () => {
            if (dot.matches(':focus-visible')) {
              this.focusedDot = dot;
              update();
            }
          }, options);

          dot.addEventListener('blur', () => {
            if (this.focusedDot === dot) this.focusedDot = null;
            update();
          }, options);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.showDot(null);
        }, options);

        window.addEventListener('resize', () => {
          if (this.activeDot) this.positionTooltip(this.activeDot);
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      showDot(dot) {
        this.activeDot?.classList.remove('is-active');
        this.activeDot = dot;
        if (!dot) return;
        this.positionTooltip(dot);
        dot.classList.add('is-active');
      }

      positionTooltip(dot) {
        const tooltip = dot.querySelector('[data-tooltip]');
        if (!tooltip) return;

        const bounds = this.getBoundingClientRect();
        const dotBounds = dot.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
        const left = Math.max(8, bounds.left + 8);
        const right = Math.min(viewportWidth - 8, bounds.right - 8);
        const top = Math.max(8, bounds.top + 8);
        const bottom = Math.min(viewportHeight - 8, bounds.bottom - 8);

        tooltip.style.maxWidth = `${Math.max(1, Math.min(260, right - left))}px`;
        tooltip.style.setProperty('--tooltip-shift', '0px');
        dot.dataset.tooltipSide = 'above';

        const above = dotBounds.top - top;
        const below = bottom - dotBounds.bottom;
        if (above < tooltip.offsetHeight && below > above) {
          dot.dataset.tooltipSide = 'below';
        }

        const tooltipBounds = tooltip.getBoundingClientRect();
        let shift = 0;
        if (tooltipBounds.left < left) {
          shift = left - tooltipBounds.left;
        } else if (tooltipBounds.right > right) {
          shift = right - tooltipBounds.right;
        }
        tooltip.style.setProperty('--tooltip-shift', `${shift}px`);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
